namespace GeniuzPOS.QRreport {
    export interface QRywcSpec1317Form {
        ReportId: Serenity.LookupEditor;
        ReportName: Serenity.StringEditor;
        UrlReport: Serenity.StringEditor;
        DataStructureName: Serenity.StringEditor;
        LineNo: Serenity.IntegerEditor;
        DateBegin: Serenity.DateEditor;
        DateEnd: Serenity.DateEditor;
        ShopId: Serenity.LookupEditor;
        MbId: Serenity.LookupEditor;
    }

    export class QRywcSpec1317Form extends Serenity.PrefixedContext {
        static formKey = 'QRreport.QRywcSpec1317';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QRywcSpec1317Form.init)  {
                QRywcSpec1317Form.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DateEditor;

                Q.initFormType(QRywcSpec1317Form, [
                    'ReportId', w0,
                    'ReportName', w1,
                    'UrlReport', w1,
                    'DataStructureName', w1,
                    'LineNo', w2,
                    'DateBegin', w3,
                    'DateEnd', w3,
                    'ShopId', w0,
                    'MbId', w0
                ]);
            }
        }
    }
}
